module.exports = __webpack_public_path__ + "img/Loading_icon.493418ba.gif";